import { SortingDirection } from '../constants'
import { Sorting, UseSortingModel } from '../types/Sorting'
import { useState } from 'react'

export type UseSortingProps = {
    initialSorting: Sorting
}

export const useSorting = ({ initialSorting }: UseSortingProps): UseSortingModel => {
    const [sorting, setSorting] = useState<Sorting>(initialSorting)

    const sortHandler = (sortBy: string): void => {
        setSorting((current) => {
            if (current?.sortBy === sortBy) {
                return {
                    sortBy,
                    direction:
                        current.direction === SortingDirection.ASCENDING
                            ? SortingDirection.DESCENDING
                            : SortingDirection.ASCENDING,
                }
            }
            return { sortBy, direction: SortingDirection.ASCENDING }
        })
    }

    return {
        sorting,
        sortHandler,
    }
}
